class SizeGuideDrawer extends Theme.Component {
  constructor() {
    super();
    this.events();
  }

  connectedCallback() {
    document.addEventListener("sizeguidedrawer:click", () => {
      this.show();
    });
    requestAnimationFrame(() => {
      this.initVideoObserver();
    });
  }

  show() {
    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
    this.pauseAllVideos();
  }

  initVideoObserver() {
    const root = this.querySelector('.size-guide-content');
    const videos = this.querySelectorAll('component-video');

    if (!root || !videos.length) {
      return;
    }

    const playThreshold = 0.8;

    this.videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const videoComponent = entry.target;

        if (entry.intersectionRatio >= playThreshold && this.classList.contains('state--active')) {
          if (!videoComponent.hasAttribute('user-paused')) {
            videoComponent.play();
          }
        } else {
          videoComponent.pause();
          videoComponent.removeAttribute('user-paused');
        }
      });
    }, {
      root: root,
      threshold: [0, playThreshold]
    });

    videos.forEach((videoComponent) => {
      this.videoObserver.observe(videoComponent);
    });
  }

  pauseAllVideos() {
    const videos = this.querySelectorAll('component-video');
    videos.forEach((videoComponent) => {
      videoComponent.removeAttribute('user-paused');
      videoComponent.pause();
    });
  }

  disconnectedCallback() {
    if (this.videoObserver) {
      this.videoObserver.disconnect();
    }
  }
}

customElements.define("size-guide-drawer", SizeGuideDrawer);